/**
 * @generated SignedSource<<2d1d1051f2c7f2e7493bcbb575332b4a>>
 * @relayHash 63b97f1eefc5601709b2c230c9f95987
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 63b97f1eefc5601709b2c230c9f95987

import type { ConcreteRequest } from 'relay-runtime';
export type IssueBodyRefetchQuery$variables = {
  id: string;
};
export type IssueBodyRefetchQuery$data = {
  readonly node: {
    readonly bodyHTML?: string;
  } | null | undefined;
};
export type IssueBodyRefetchQuery = {
  response: IssueBodyRefetchQuery$data;
  variables: IssueBodyRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "unfurlReferences",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "bodyHTML",
      "storageKey": "bodyHTML(unfurlReferences:true)"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueBodyRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "IssueBodyRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "63b97f1eefc5601709b2c230c9f95987",
    "metadata": {},
    "name": "IssueBodyRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b188643d39e8e405216bfb7842769f12";

export default node;
